







































import { computed, defineComponent} from '@nuxtjs/composition-api';
import { PropType } from 'vue';
import type {MbookOptionType} from '~/utils/types';
import {PHYSICAL} from '~/utils/constants/product';
import Price from '~/components/Price.vue';
import AddToCart from '~/components/AddToCart.vue';

export default defineComponent({
    components:{
        Price,
        AddToCart
    },
    props:{
        sku:{
            type: String,
            required: true
        },
        options:{
            type: Array as PropType<Array<MbookOptionType>>,
            required:true
        },
        optionAttributeUid:{
            type:String,
            required: true
        }
    },
    methods:{
        getIsShippable(option){
            return option.variant.tipologia_libro == PHYSICAL;
        },
        /**
         * This logic is inherited from the old site. @TODO define a way to manage this, c'mon!
         */
        getShippingCost(option){
            if (option.variant.price_range.maximum_price.final_price.value >= 30) return this.$t('Free shipping')
            else return `+ ${this.$fc(3.9)}`
        }
       
    },
    setup(props){
        /**
         * creating an utility object having the object optionConfiguration as { <natura_config_option.attribute_uid> : <variant uid> } to easily
         * access it for addTo Cart function
         */
        let optTmp = {};
        props.options.forEach(opt => {
            optTmp[opt.uid] = {};
            optTmp[opt.uid][props.optionAttributeUid] = opt.uid;
        })

        //const optionConfigurations = ref<{[k:string]:any}>(optTmp)

        const optionConfigurations = computed(()=>{
            let optTmp = {};
            props.options.forEach(opt => {
                optTmp[opt.uid] = {};
                optTmp[opt.uid][props.optionAttributeUid] = opt.uid;
            });
            return optTmp;
        })


        return{
            optionConfigurations
        }
    }
})
